import { registerSW } from './registerSW';

export async function redirect() {

	try {
		// Warte bis Service Worker aktiv ist
		await navigator.serviceWorker.ready;

		const params = new URLSearchParams(window.location.search);
		const orientation = params.get('orientation');
		const prefersReducedMotion = params.get('prefers-reduced-motion');
		const apk = params.get('apk') === 'true';
		const apkVersion = params.get('version');
		const deviceType = params.get('device-type');

		const url = new URL(`${window.location.origin}/mpa/index.html`);
		if (orientation) url.searchParams.set('orientation', orientation);
		if (apk) url.searchParams.set('apk', 'true');
		if (prefersReducedMotion)
			url.searchParams.set('prefers-reduced-motion', prefersReducedMotion);
		if (apkVersion) url.searchParams.set('version', apkVersion);
		if (deviceType) url.searchParams.set('device-type', deviceType);

		window.location.replace(url);
	} catch (err) {
		console.warn('Service Worker not ready, retrying in 1s');
		registerSW();
		setTimeout(() => redirect(), 1000);
	}
}
